module.exports = __webpack_public_path__ + "img/category-popular-hover.aa197fab.png";